import { Table } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import axios from "axios";
import "../components/Reminder.css";
import { API_URL } from "../App";
import { UserDataContext } from "../components/UserDataContext";
import useCountStore from "../components/store";
import { useNavigate } from "react-router-dom";

export default function DataBowCalendar({ idVal }) {
  const { userData } = useContext(UserDataContext);
  const [data, setData] = useState([]);
  const [id, setId] = useState();
  const navigate = useNavigate();
  const count = useCountStore((state) => state.count);
  const setCount = useCountStore((state) => state.setCount);

  useEffect(() => {
    const fetchData = async () => {
      const url = `${API_URL}/getuserbowcalendarusage/${userData.cookie}/${idVal}`;
      try {
        const response = await axios.get(url);
        setData(response.data);
      } catch (error) {
        console.error(
          "Błąd podczas pobierania danych. Najprawdopodobniej utracono połączenie z internetem.",
          error
        );
      }
    };

    if (userData && count) {
      fetchData();

      const intervalId = setInterval(fetchData, 1000);
      return () => clearInterval(intervalId);
    }
  }, [userData, count]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [open, setOpen] = useState(false);
  const handleOpen = (id) => {
    setOpen(true);
    setId(id);
  };

  const handleClose = () => setOpen(false);
  const handleDelete = async () => {
    try {
      const response = await axios.put(
        API_URL + `/deleteremindermedcalendar/${userData.cookie}/${idVal}`,
        { id: id },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.error === 200) {
        setCount(count + 1);
      }
    } catch (error) {
      console.error("Błąd podczas próby skasowania elementu", error);
    }
    setOpen(false);
  };

  if (userData && userData.grpAdmin === "1") {
    return (
      <div>
        <Table striped bordered hover size="sm">
          <thead>
            <tr>
              <th className="center">Kiedy przyjąć</th>
              <th className="center">Lek</th>
              <th className="center">Dawka</th>
              <th className="center">Pora</th>
              <th className="center">Czas przyjęcia</th>
              <th className="center">Informacje</th>
            </tr>
          </thead>
          <tbody>
            {Array.isArray(data) && data.length > 0 ? (
              data.map((item) => (
                <tr key={item.id}>
                  <td data-label="Kiedy przyjąć" className="center">
                    {item.datebow}
                  </td>
                  <td data-label="Lek" className="center">
                    {item.bow}
                  </td>
                  <td data-label="Dawka" className="center">
                    {item.dose}
                  </td>
                  <td data-label="Pora" className="center">
                    {item.part}
                  </td>
                  <td data-label="Czas przyjęcia" className="center">
                    {item.forgotten === "1" ? (
                      <span className="red-italic">Dawka pominięta</span>
                    ) : (
                      item.deletedat
                    )}
                  </td>
                  <td data-label="Informacje" className="center">
                    {item.description}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="center">
                  Brak danych do wyświetlenia
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}
